import { PlayIcon } from './Icons'
import { STUDIO_HASH } from '../routes'

type CampaignHudProps = {
  onStartStory: () => void
}

export function CampaignHud({ onStartStory }: CampaignHudProps) {
  return (
    <header className="campaign-hud">
      <h1
        className="campaign-title"
        tabIndex={-1}
        aria-label="The Million Dollar Model X"
      >
        <span>The</span>
        <span>Million Dollar</span>
        <span>Model X</span>
      </h1>

      <p className="campaign-goal">$1,000,000 campaign goal</p>
      <p className="campaign-status">Placement map in development</p>
      <div className="campaign-hud__actions">
        <button
          className="outline-button story-button"
          type="button"
          onClick={onStartStory}
        >
          <PlayIcon />
          Start the story
        </button>
        <a
          className="outline-button campaign-studio-button"
          href={STUDIO_HASH}
          aria-label="Open Placement Studio"
        >
          Placement Studio
        </a>
      </div>
    </header>
  )
}
